<template>
  <div class="stepCard-body">
    <div>
      <div class="step-number">{{ stepNumber }}.</div>
      <div class="step-title">{{ title }}</div>
    </div>
    <div class="step-text">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StepCard",
  props: {
    stepNumber: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.stepCard-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 3px solid #e6e6f3;
  gap: 20px;
  padding: 50px;
}

.step-number {
  font-size: 55px;
  font-weight: 600;
  color: #f98140;
}

.step-title {
  font-size: 22px;
  font-weight: 500;
  color: #000000;
}

.step-text {
  font-size: 16px;
  color: 434343;
}

@media (max-width: 1280px) {
  .step-text {
    font-size: 14px;
  }
}

@media (max-width: 744px) {
  .stepCard-body {
    padding: 30px;
  }
  .step-title {
    font-size: 20px;
  }
  .step-text {
    font-size: 12px;
  }
}

@media (max-width: 588px) {
  .stepCard-body {
    padding: 30px 0px;
  }
}
</style>
